import { GoogleMap, GoogleMapProps } from "@react-google-maps/api";
import React, { FC, useMemo } from "react";

import { useStoreLocator } from "../../../../hooks/use-store-locator";
import { mapOptions } from "./map-options";
import { StoreLocatorMarker } from "./store-locator-marker";

export interface StoreLocatorMapProps extends GoogleMapProps {}

export const StoreLocatorMap: FC<StoreLocatorMapProps> = ({ ...rest }) => {
  const { filteredStores: stores } = useStoreLocator();

  const markers = useMemo(() => {
    return stores.map((store, i) => {
      const { lat, lng, siteType } = store;
      return (
        lat &&
        lng &&
        siteType && <StoreLocatorMarker store={store} position={{ lat, lng }} key={i} />
      );
    });
  }, [stores]);

  return (
    <GoogleMap
      options={mapOptions}
      mapTypeId="roadmap"
      mapContainerClassName="h-screen lg:h-[90vh]"
      zoom={6}
      {...rest}
    >
      {markers}
    </GoogleMap>
  );
};
